import { useEffect, useMemo, useState } from "react";
import { getCoinIconCandidates } from "@/lib/coinIcon";

/**
 * Rounded coin logo — tries CoinGecko / CoinCap / spothq CDN before letter badge.
 */
export default function CoinIcon({ symbol, image, size = 32, className = "" }) {
  const sym = String(symbol || "?").toUpperCase();
  const candidates = useMemo(() => getCoinIconCandidates(sym, image), [sym, image]);
  const [idx, setIdx] = useState(0);
  const [failed, setFailed] = useState(false);
  const px = typeof size === "number" ? size : 32;

  useEffect(() => {
    setIdx(0);
    setFailed(false);
  }, [sym, image]);

  if (failed || !candidates.length) {
    return (
      <span
        className={`inline-grid place-items-center rounded-full shrink-0 font-bold text-white bg-[#022CED] ${className}`}
        style={{ width: px, height: px, fontSize: Math.max(10, px * 0.38) }}
        aria-hidden
      >
        {sym.slice(0, 2)}
      </span>
    );
  }

  const src = candidates[Math.min(idx, candidates.length - 1)];

  return (
    <img
      src={src}
      alt=""
      width={px}
      height={px}
      className={`rounded-full object-cover bg-white shrink-0 ${className}`}
      style={{ width: px, height: px }}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      onError={() => {
        if (idx + 1 < candidates.length) {
          setIdx((i) => i + 1);
        } else {
          setFailed(true);
        }
      }}
    />
  );
}
